import {TextField} from '@ultradent/components';
import {Route} from 'react-router-dom';
import {routes} from './routes';
import {Form, Formik} from 'formik';
import Icon from '@components/common/Icon';
import useProductDocumentationSearch from '@containers/Resources/ProductDocumentation/useProductDocumentationSearch';

const LBL_SEARCH = upi.i18n.getTextFromKey( 'lbl-searchForProduct', 'Search for a Product' );
const LBL_KEYWORD = upi.i18n.getTextFromKey( 'lbl-keywordItemNum', 'Keyword / Item#' );

export default function App ( {productList} ) {
    const productDocumentationApi = useProductDocumentationSearch( {data: productList} );

    return (
        <Formik
            onSubmit={productDocumentationApi.onQuery}
            enableReinitialize={true}
            initialValues={{
                productCategory: productDocumentationApi.currentQuery.productCategory,
                productLanguage: productDocumentationApi.currentQuery.productLanguage,
                keyword: productDocumentationApi.currentQuery.keyword
            }}
            render={( {values, handleChange} ) => (
                <Form>
                    <div class="md:flex w-full" data-testid="product-documentation-list">
                        <div className="md:w-1/4">
                            <div className="mb-6 px-6 pb-2 border border-grey-lighter border-solid">
                                <fieldset>
                                    <div className="input-group">
                                        <TextField
                                            id="keyword"
                                            inputClassName="py-6"
                                            label={LBL_SEARCH}
                                            value={values.keyword}
                                            onChange={handleChange}
                                            placeholder={LBL_KEYWORD}
                                            append={<Icon.ui name="search" wrapperClassName="block w-5 h-5"/>}
                                        />
                                    </div>
                                </fieldset>
                            </div>
                        </div>

                        <div className="md:w-3/4">
                            <div className="md:ml-8 flex-auto">
                                 {routes.map( ( route, index ) => {
                                     const componentProp = route.render
                                         ? {render: route.render( productDocumentationApi )}
                                         : {component: route.main};

                                     return <Route
                                         key={index}
                                         path={route.path}
                                         exact={route.exact}
                                         {...componentProp}
                                     />
                                 } )}
                            </div>

                        </div>
                    </div>
                </Form>
            )}/>
    );
}
